/**
 * Shared HTTP client for Quiz Editor API (cookie SSO).
 * Registered as DI token `http` by bootstrap.
 */
import { API_BASE } from '../foundation/index.js';

/**
 * @param {string} path
 * @param {RequestInit & { body?: unknown }} [options]
 */
async function request(path, options = {}) {
  const { body, headers, ...rest } = options;
  const isFormData = typeof FormData !== 'undefined' && body instanceof FormData;
  const res = await fetch(`${API_BASE}${path}`, {
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      ...(body != null && !isFormData ? { 'Content-Type': 'application/json' } : {}),
      ...(headers || {}),
    },
    body: body != null ? (isFormData ? body : JSON.stringify(body)) : undefined,
    ...rest,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.message || data.code || `HTTP ${res.status}`);
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

export function createQuizEditorHttp() {
  return {
    get: (url) => {
      const path = url.startsWith(API_BASE) ? url.slice(API_BASE.length) : url;
      return request(path.startsWith('/') ? path : `/${path}`);
    },
    post: (url, body) => {
      const path = url.startsWith(API_BASE) ? url.slice(API_BASE.length) : url;
      return request(path.startsWith('/') ? path : `/${path}`, { method: 'POST', body });
    },
    put: (url, body) => {
      const path = url.startsWith(API_BASE) ? url.slice(API_BASE.length) : url;
      return request(path.startsWith('/') ? path : `/${path}`, { method: 'PUT', body });
    },
    delete: (url) => {
      const path = url.startsWith(API_BASE) ? url.slice(API_BASE.length) : url;
      return request(path.startsWith('/') ? path : `/${path}`, { method: 'DELETE' });
    },
    request,
  };
}
